import { useTranslation } from "react-i18next";

// Define the type for VacancyApplicantEmploymentStatus keys
export type VacancyApplicantEmploymentStatus =
  | "employed"
  | "self-employed"
  | "civilServant"
  | "student"
  | "lookingForWork"
  | "other";

export const VACANCY_ACCORDION_LIST_PREFIX = "vacancy-applicant-list";

const useVacancyActivity = () => {
  const { t } = useTranslation();

  const vacancyApplicantEmploymentStatusOptions = [
    {
      key: "employed",
      label: t("apTemplate:Vacancy.Applicant.EmploymentStatus.employed", "Angestellt"),
    },
    {
      key: "self-employed",
      label: t(
        "apTemplate:Vacancy.Applicant.EmploymentStatus.self-employed",
        "Selbstständig"
      ),
    },
    {
      key: "civilServant",
      label: t("apTemplate:Vacancy.Applicant.EmploymentStatus.civilServant", "Beamter"),
    },
    {
      key: "student",
      label: t("apTemplate:Vacancy.Applicant.EmploymentStatus.student", "Student"),
    },
    {
      key: "lookingForWork",
      label: t(
        "apTemplate:Vacancy.Applicant.EmploymentStatus.lookingForWork",
        "Arbeitssuchend"
      ),
    },
    {
      key: "other",
      label: t("apTemplate:Vacancy.Applicant.EmploymentStatus.other", "Andere"),
    },
  ] as const;

  const getEmploymentStatusLabel = (key: string) => {
    const option = vacancyApplicantEmploymentStatusOptions.find(
      (option) => option.key === key
    );
    return option ? option.label : key;
  };

  return {
    vacancyApplicantEmploymentStatusOptions,
    getEmploymentStatusLabel,
  };
};

export default useVacancyActivity;
